import { CalendarIntegration } from '../../calendar/CalendarIntegration';
import { GmailIntegration } from '../../email/GmailIntegration';

/**
 * Consolidated per-user integrations tab (Calendar + Gmail).
 *
 * When `userId` is null the person has no linked user account, so OAuth
 * connections aren't possible — a placeholder message is shown instead.
 */
export function PersonIntegrationsTab({ userId }: { userId: string | null }) {
  if (!userId) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-6 text-center">
        <p className="text-sm text-gray-500">
          Această persoană nu are un cont de utilizator asociat. Integrările per-utilizator (Google
          Calendar, Gmail) necesită un cont activ.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Google Calendar */}
      <section className="rounded-lg border border-gray-200 bg-white p-5">
        <h3 className="mb-3 text-sm font-semibold text-gray-900">Google Calendar</h3>
        <CalendarIntegration userId={userId} />
      </section>

      {/* Gmail */}
      <section className="rounded-lg border border-gray-200 bg-white p-5">
        <h3 className="mb-3 text-sm font-semibold text-gray-900">Gmail (Read-Only)</h3>
        <GmailIntegration userId={userId} />
      </section>
    </div>
  );
}
